import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentOnAccountPage } from 'src/app/modals/checkout-payment-on-account/checkout-payment-on-account.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentOnAccountPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentOnAccountPage]
})
export class CheckoutPaymentOnAccountPageModule {}
